module.exports = __webpack_public_path__ + "static/media/gallery10.bd94af96.jpg";